import styled from 'styled-components';
import { media } from 'helpers/breakpoints';
import { TabSelector } from 'components/Toolkit/TabSelector/TabSelector';

const ReviewTitle = styled.div`
  ${({ theme }) => theme.fontSize.L18}
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

const TabItem = styled.span`
  ${({ theme }) => theme.fontSize.L18}
  color: ${({ theme }) => theme.colors.GREY_DARKER};
`;

const Feedback = styled.div`
  display: flex;
  flex-flow: column;

  ${media.medium} {
    grid-column: 2 / 3;
  }
`;

const FeedbackSelector = styled(TabSelector)`
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  border-bottom: 1px solid ${({ theme }) => theme.colors.GREY_LIGHT};
`;

const Tags = styled.ul`
  display: flex;
  gap: ${({ theme }) => theme.spacing.S8};
  flex-wrap: wrap;
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  ${media.medium} {
    max-height: 118px; // Tags are not allowed to expand beyond 3 rows a tag is 34px high with 8px gap = 34 x 3 + 8 x 2 = 118
    margin-bottom: 0;
    overflow: hidden;
  }
`;

const DisplayTagSpacer = styled.span`
  margin: ${({ theme }) => `0 ${theme.spacing.S4}`};
`;

const ReviewSubTitle = styled.p`
  ${({ theme }) => theme.fontSize.M16}
  color: ${({ theme }) => theme.colors.GREY_DARK};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  flex: 1 1 auto;
  align-self: center;
  align-content: center;
`;
export {
  ReviewTitle,
  TabItem,
  Feedback,
  FeedbackSelector,
  Tags,
  DisplayTagSpacer,
  ReviewSubTitle,
};
